function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalScrollView = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["style", "contentContainerStyle", "spacerStyle", "children", "onScrollEnd", "visibleItems", "gap"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var HorizontalScrollView = exports.HorizontalScrollView = (0, _react.memo)(function (_ref) {
  var _process, _process$env;
  var style = _ref.style,
    contentContainerStyle = _ref.contentContainerStyle,
    spacerStyle = _ref.spacerStyle,
    children = _ref.children,
    onScrollEnd = _ref.onScrollEnd,
    _ref$visibleItems = _ref.visibleItems,
    visibleItems = _ref$visibleItems === void 0 ? 1 : _ref$visibleItems,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 8 : _ref$gap,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _scrollViewRef = (0, _react.useRef)(null);
  var _indicatorBarRef = (0, _react.useRef)(null);
  var _indicatorRef = (0, _react.useRef)(null);
  var _scrollViewX = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var _isDrag = (0, _react.useRef)(false);
  var _hasCalledOnScrollEnd = (0, _react.useRef)(false);
  var _childrenCount = _react["default"].Children.count(children);
  var mockSizes;
  if (process && (_process = process) != null && (_process$env = _process.env) != null && _process$env.JEST_WORKER_ID) {
    mockSizes = {
      container: 1024
    };
  }
  var _useState = (0, _react.useState)(Object.assign({
      difference: 0,
      visible: 0,
      indicator: 0,
      container: 0,
      containerOuter: 0,
      total: 0
    }, mockSizes)),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _sizes = _useState2[0],
    _setSizes = _useState2[1];
  var _onScroll = function _onScroll(_ref2) {
    var x = _ref2.nativeEvent.contentOffset.x;
    if (_isDrag.current === false) {
      _scrollViewX.setValue(x);
    }
    if (_hasCalledOnScrollEnd.current === false && x >= _sizes.total - _sizes.container) {
      _hasCalledOnScrollEnd.current = true;
      onScrollEnd == null ? void 0 : onScrollEnd();
    }
  };
  var _onLayout = function _onLayout(_ref3) {
    var _indicatorBarRef$curr;
    var containerOuter = _ref3.nativeEvent.layout.width;
    (_indicatorBarRef$curr = _indicatorBarRef.current) == null ? void 0 : _indicatorBarRef$curr.measure(function (_x, _y, width) {
      if (width) {
        var _singleGap = gap * (visibleItems - 1) / visibleItems;
        var visible = width / visibleItems - _singleGap;
        _setSizes(function (prevState) {
          return Object.assign({}, prevState, {
            container: width,
            containerOuter: containerOuter,
            visible: visible
          });
        });
      }
    });
  };
  var _updateSizes = (0, _react.useCallback)(function () {
    _setSizes(function (prevState) {
      var container = prevState.container,
        visible = prevState.visible;
      var total = visible * _childrenCount + gap * (_childrenCount - 1);
      var indicator = Math.ceil(container / total * container);
      if (_react["default"].Children.count(children) === 1) {
        indicator = container;
      }
      var difference = container > indicator ? container - indicator : 0;
      return Object.assign({}, prevState, {
        difference: difference,
        indicator: indicator,
        total: total
      });
    });
  }, [_childrenCount, children, gap]);
  var _onContentSizeChange = function _onContentSizeChange() {
    _updateSizes();
  };
  var _onResponderGrant = function _onResponderGrant() {
    _isDrag.current = true;
  };
  var _onResponderMove = function _onResponderMove(_ref4) {
    var _scrollViewRef$curren;
    var pageX = _ref4.nativeEvent.pageX;
    var indicator = _sizes.indicator,
      container = _sizes.container,
      containerOuter = _sizes.containerOuter,
      total = _sizes.total;
    var _newX = total * ((pageX - indicator / 2) / containerOuter);
    (_scrollViewRef$curren = _scrollViewRef.current) == null ? void 0 : _scrollViewRef$curren.scrollTo({
      x: Math.min(Math.max(0, _newX), total - container),
      animated: false
    });
    _scrollViewX.setValue(_newX);
  };
  var _onResponderRelease = function _onResponderRelease() {
    _isDrag.current = false;
  };
  var _onStartShouldSetResponder = function _onStartShouldSetResponder() {
    return true;
  };
  var _onMoveShouldSetResponder = function _onMoveShouldSetResponder() {
    return true;
  };
  var _onResponderTerminationRequest = function _onResponderTerminationRequest() {
    return false;
  };
  var _scrollViewDisplay = _sizes.container === 0 ? 'none' : 'flex';
  (0, _react.useEffect)(function () {
    _hasCalledOnScrollEnd.current = false;
    _updateSizes();
  }, [children, _updateSizes]);
  return (0, _jsxRuntime.jsxs)(_reactNative.View, Object.assign({
    style: [styles.container, style],
    testID: "HorizontalScrollView"
  }, props, {
    children: [(0, _jsxRuntime.jsx)(_reactNative.ScrollView, {
      testID: "HorizontalScrollViewScroller",
      ref: _scrollViewRef,
      horizontal: true,
      showsHorizontalScrollIndicator: false,
      showsVerticalScrollIndicator: false,
      scrollEventThrottle: 16,
      onContentSizeChange: _onContentSizeChange,
      onScroll: _onScroll,
      contentContainerStyle: [contentContainerStyle],
      style: {
        display: _scrollViewDisplay
      },
      children: (0, _jsxRuntime.jsxs)(_reactNative.View, {
        style: {
          flexDirection: 'row'
        },
        children: [(0, _jsxRuntime.jsx)(_reactNative.View, {
          style: [styles.spacer, spacerStyle]
        }), _react["default"].Children.map(children, function (child, index) {
          if (!child) return null;
          return (0, _jsxRuntime.jsx)(_reactNative.View, {
            style: {
              width: _sizes.visible,
              marginLeft: index === 0 ? 0 : gap
            },
            children: child
          }, index);
        }), (0, _jsxRuntime.jsx)(_reactNative.View, {
          style: [styles.spacer, spacerStyle]
        })]
      })
    }), (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: styles.indicatorContainer,
      onStartShouldSetResponder: _onStartShouldSetResponder,
      onMoveShouldSetResponder: _onMoveShouldSetResponder,
      onResponderGrant: _onResponderGrant,
      onResponderMove: _onResponderMove,
      onResponderRelease: _onResponderRelease,
      onResponderTerminationRequest: _onResponderTerminationRequest,
      onLayout: _onLayout,
      children: (0, _jsxRuntime.jsx)(_reactNative.View, {
        ref: _indicatorBarRef,
        style: styles.indicatorBar,
        children: (0, _jsxRuntime.jsx)(_reactNative.Animated.View, {
          ref: _indicatorRef,
          style: [styles.indicator, {
            width: _sizes.indicator,
            transform: [{
              translateX: _reactNative.Animated.multiply(_scrollViewX, _sizes.indicator / _sizes.container).interpolate({
                inputRange: [0, _sizes.difference],
                outputRange: [0, _sizes.difference],
                extrapolate: 'clamp'
              })
            }]
          }]
        })
      })
    })]
  }));
});